import React, { useState } from "react"
import tw from "twin.macro"
import { useTranslation } from "next-i18next"
import { Button, ButtonTheme } from "../formElements/button"
import { Modal } from "../modal"
import { Authentication, AuthenticatonPage } from "../authentication"
import { NavBarProp } from "."

export const LoggedOut = ({ isblack }: NavBarProp) => {
  const { t } = useTranslation("nav")
  const [view, setView] = useState(AuthenticatonPage.Join)
  const [show, setShow] = useState(false)
  const [isNotDismissable, setNotDismissable] = useState(false)
  const modalProps = {
    show,
    setShow,
    notDismissable: isNotDismissable,
    component: <Authentication view={view} setShow={setShow} setNotDismissable={setNotDismissable} />,
  }
  return (
    <div tw="py-0.5 flex items-center tablet-lg:(space-x-4)">
      <Button
        twStyle={isblack ? tw`border-white text-white` : tw``}
        dataTestId="nav-login"
        action={t("login")}
        theme={ButtonTheme.PrimaryOutline}
        onClick={() => {
          setView(AuthenticatonPage.Login)
          setShow(true)
        }}
      />
      <span tw="hidden tablet-lg:(block)">
        <Button
          twStyle={isblack ? tw`bg-white text-base-6` : tw``}
          dataTestId="nav-signup"
          action={t("signup")}
          onClick={() => {
            setView(AuthenticatonPage.Join)
            setShow(true)
          }}
        />
      </span>
      <Modal {...modalProps} />
    </div>
  )
}
